import login from "./login";
import facebookLogin from "./facebookLogin";
import { socialProviders } from "../socialProviders";

export function getLoginMethod(loginConfig) {
  if (isNormalLogin(loginConfig)) {
    return login;
  } else if (isFacebookLogin(loginConfig)) {
    return facebookLogin;
  }
}

function isNormalLogin(config) {
  return !!(config.username && config.password);
}

function isFacebookLogin(config) {
  return config.provider === socialProviders.FACEBOOK;
}
